// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"dcbf84a9","252":"df346133","919":"83b6ad3a","939":"4d521ca3","982":"f4f405b5"}[chunkId] + ".chunk.js";
};